<div class="flow">
  <div class="flow__nav">
    <button class="btn-icon blue" (click)="goBack()" [class.hidden]="isAtStart || isAtEnd">
      <mat-icon>chevron_left</mat-icon>
      <span>Tilbage</span>
    </button>
    <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk" [class.hidden]="isAtEnd">
      <mat-icon svgIcon="remove"></mat-icon>
    </button>
    <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
  </div>
  <div class="flow__stage">
    <ng-container>
      <mat-horizontal-stepper linear #stepper class="no-stepper-nav">
        <mat-step #firststep>
          <div class="flow__step-content">
            <h1 class="medium">Hvornår skal kunden opsiges?</h1>
            <app-opsig-date
              [form]="opsigDateForm"
              [periodEndDate]="currentIntervalEnddate"
              [serviceaftale]="serviceaftale"
            ></app-opsig-date>
            @if (shouldWarnSlutopgInOldInterval) {
              <div>
                <p>
                  Du er ved at opsige en serviceaftale med en opsigelsesdato tilbage i tid, selvom der er aktivitet i en senere
                  serviceperiode.
                </p>
                <p>Det er normalt ikke tilladt. Check venligst datoer og bekræft opsigelse.</p>
                <p>Bemærk: Der skal efterfølgende foretages manuel slutopgørelse, såfremt opsigelsesdato fastholdes.</p>
              </div>
            }
            <div class="flow__step-actions">
              <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(opsigDateForm?.invalid)">Videre</button>
            </div>
          </div>
        </mat-step>
        @if (
          opsigDateForm.controls.opsigPr.value == opsigPr.Custom &&
          upcomingChanges &&
          (upcomingChanges.hasServiceabonnementChanges || upcomingChanges.hasTilvalgChanges)
          ) {
          <mat-step
            #secondStep
            >
            <div class="flow__step-content">
              <h1 class="medium">Der er allerede fremtidige ændringer på aftalen!</h1>
              <app-upcoming-changes
                [serviceaftale]="serviceaftale"
                [upcomingChanges]="upcomingChanges"
                [showPartnerChanges]="false"
              ></app-upcoming-changes>
              <h2 class="margin--top-xl">Vil du fjerne disse ændringer for at gennemføre den fremtidige opsigelse?</h2>
              <div class="flow__step-actions">
                <button mat-raised-button matStepperNext color="primary">Ja, fjern ændringer</button>
              </div>
            </div>
          </mat-step>
        }
        <mat-step #thirdStep>
          <div class="flow__step-content">
            <h1 class="medium">Hvilke udestående serviceordrer skal annulleres?</h1>
            <app-open-orders-cancel
              [form]="openOrdersForm"
              [endDate]="opsigDateForm.controls.endDate.value"
              [allOrders]="serviceOrders"
              (cancelOrderChanged)="onCancelOrderChanged($event)"
            ></app-open-orders-cancel>
            <div class="flow__step-actions">
              <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(openOrdersForm?.invalid)">Videre</button>
            </div>
          </div>
        </mat-step>
        <mat-step #fourthStep>
          <div class="flow__step-content">
            <h1 class="medium">Hvad er årsagen til opsigelsen?</h1>
            <app-termination-reason [form]="terminationCauseForm" [terminationCauses]="terminationCauses"></app-termination-reason>
            <div class="flow__step-actions">
              <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(terminationCauseForm?.invalid)">Videre</button>
            </div>
          </div>
        </mat-step>
        <mat-step #fifthStep>
          <div class="flow__step-content">
            <h1 class="medium">Skal der sendes et opsigelsesbrev til kunden?</h1>
            <app-send-letter
              [form]="sendLetterForm"
              [email]="$safeNavigationMigration(serviceaftale?.kunde?.anlaegsadresse?.email)"
              (reload)="reloadServiceAftale()"
            ></app-send-letter>
            <div class="flow__step-actions">
              <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(sendLetterForm?.invalid)">Videre</button>
            </div>
          </div>
        </mat-step>
        @if (shouldAllowSlutopg && serviceaftale) {
          <mat-step #sixthStep>
            <div class="flow__step-content">
              <h1 class="medium">Hvad skal kunden faktureres?</h1>
              <app-slutopgoerelse
                [form]="slutopgoerelseForm"
                [kundeSegment]="$safeNavigationMigration(serviceaftale?.kunde?.kundetype?.kundeSegment)"
                [currentServiceinterval]="$safeNavigationMigration(serviceaftale?.currentServiceinterval)"
                [isWithFrieTilkald]="$safeNavigationMigration(serviceaftale?.hasFrieTilkald)"
                [eftersynsInterval]="$safeNavigationMigration(serviceaftale?.serviceAbonnement?.eftersynInterval)"
                [serviceaftaleId]="$safeNavigationMigration(serviceaftale?.id)"
                [endDate]="opsigDateForm.controls.endDate.value"
              ></app-slutopgoerelse>
              @if (endDateTodayOrBefore) {
                <app-slutopgoerelse-draft
                  [form]="slutopgoerelseForm"
                  [serviceaftaleId]="$safeNavigationMigration(serviceaftale?.id)"
                  [kundesegment]="$safeNavigationMigration(serviceaftale?.kunde?.kundetype?.kundeSegment)"
                  [endDate]="opsigDateForm.controls.endDate.value"
                ></app-slutopgoerelse-draft>
              }
              @if (slutopgoerelseForm.controls.createSlutopgoerelse.value) {
                <div>
                  @if (endDateTodayOrBefore) {
                    <div [formGroup]="opsigAftaleForm" class="form-row">
                      @if (serviceaftale.fakturaStop) {
                        <div class="orange icon-with-text">
                          <mat-icon svgIcon="obs-solid"></mat-icon>
                          <span>Bemærk: Der er fakturastop på aftalen</span>
                        </div>
                      }
                      <mat-slide-toggle color="primary" formControlName="afregnSlutopgoerelse">Afregn med det samme</mat-slide-toggle>
                    </div>
                  }
                  <small>{{ momsTekst() }}</small>
                </div>
              }
              <div class="flow__step-actions">
                <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(slutopgoerelseForm?.invalid)">Videre</button>
              </div>
            </div>
            <div class="flow__resume">
              <app-slutopgoerelse-quickview [serviceaftale]="serviceaftale" [endDate]="endDate"></app-slutopgoerelse-quickview>
            </div>
          </mat-step>
        }
        <mat-step #seventhStep>
          <div class="flow__step-confirm align-center">
            <h1 class="medium">Resume af opsigelse</h1>
            <div class="flow__opt-detail margin--top-xl med-text">
              <div>
                <strong>Opsigelsesdato:</strong>
                <div>
                  {{ endDate | date: 'dd.MM.yyyy' }}
                </div>
              </div>
              @if (openServiceOrders.length > 0) {
                <div class="margin--top-l">
                  <strong class="margin--bottom-s">Åbne ordre der annulleres</strong>
                  @for (order of ordersToCancel; track order) {
                    <div>
                      {{ order.deadline | date: 'dd.MM.yyyy' }} · {{ order.serviceordreType }} ·
                      <a href="/ordre/{{ order.serviceordreNo }}/edit;page=1" target="_blank" title="Vis ordre i ny fane">
                        #{{ order.serviceordreNo }}
                      </a>
                    </div>
                  }
                </div>
              }
              <div class="margin--top-l">
                <strong>Årsag til opsigelsen:</strong>
              </div>
              <div>{{ terminationCause?.text }} {{ this.terminationCauseForm.controls.terminationCauseOther.value }}</div>
              <div class="margin--top-l">
                @if (sendLetterForm.controls.sendLetter.value) {
                  <div>Der sendes opsigelsesbrev til kunden</div>
                }
                @if (!sendLetterForm.controls.sendLetter.value) {
                  <div>
                    Der sendes
                    <strong>ikke</strong>
                    opsigelsesbrev til kunden
                  </div>
                }
              </div>
              <div class="margin--top-l">
                @if (slutopgoerelseForm.controls.createSlutopgoerelse.value) {
                  <div>Der laves slutopgoerelse</div>
                }
                @if (!slutopgoerelseForm.controls.createSlutopgoerelse.value) {
                  <div>
                    Der laves
                    <strong>ikke</strong>
                    slutopgørelse
                  </div>
                }
              </div>
            </div>
            <div class="flow__step-actions">
              <button
                mat-raised-button
                appPreventDoubleClick
                (throttledClick)="save()"
                color="primary"
                [disabled]="sendLetterForm?.invalid || isLoading"
                >
                Gennemfør opsigelse
              </button>
            </div>
          </div>
        </mat-step>
        <mat-step #eighthstep>
          <div class="flow__step-confirm align-center green">
            <mat-icon svgIcon="checkmark" class="icon-64"></mat-icon>
            <br />
            <h2 class="medium">Serviceaftalen er opsagt</h2>
            <div class="flow__step-actions">
              <button mat-raised-button color="primary" replaceUrl="true" [routerLink]="['/aftale/', okKundeAftaleNr]">
                Gå til aftalen
              </button>
            </div>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </ng-container>
  </div>
</div>
@if (quickViewOpen) {
  <div class="quick-view" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="quickViewOpen = false" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <app-quickview [serviceaftale]="serviceaftale"></app-quickview>
    <div class="quick-view__bottom">
      <button mat-raised-button color="primary" [routerLink]="['/aftale', okKundeAftaleNr]">Åben aftalen</button>
    </div>
  </div>
}
